
export default {
  name: 'HoursCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How do you count weekly hours?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Record how many hours are worked each week and add them to get the total weekly hours. To calculate the average hours with an online keyboard calculator, divide the time performed by the corresponding number of weeks."
        }
      },{
        "@type": "Question",
        "name": "Can I leave when my shift is over?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The short answer is yes. You are free to leave when your shift is over. And, of course, you don't get fired if you work overtime."
        }
      },{
        "@type": "Question",
        "name": "What is the most extended shift you can legally work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "There is no exact limit to the maximum number of hours worked a day. However, the FLSA does require that employers pay their employees overtime payments at the applicable rate."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        startTime: '',
        endTime: ''
      })
    }
  },
  methods: {
    onHoursCalculator() {
        this.form.post(`/tool/hours-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
